import React from "react";
import AnnouncementBar from "../../../components/AnnouncementBar/AnnouncementBar";
import ServiceDetailIndex from "../../../components/SidetabPages/ServiceProvider/ServiceDetailIndex";

const ServiceDetailView = () => {
  return (
    <>
      <AnnouncementBar />
      <ServiceDetailIndex />
    </>
  );
};
export default ServiceDetailView;
